/* eslint-disable no-shadow */
import React, { useState, useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { components } from 'react-select';

import Select from '../../Select';

const RedirectSettings = (props) => {
  const { item, answerHandlerOpen, toggleAnswerHandler } = props;
  const items = useSelector((state) => state?.items?.allItems);
  const [selectedDestiny, setSelectedDestiny] = useState(null);

  useEffect(() => {
    if (item && items) {
      const { redirectTo } = item;
      if (redirectTo) {
        const selectedItem = items.find(({ _id }) => _id === redirectTo);
        if (selectedItem) {
          const { _id: value, title: label } = selectedItem;
          setSelectedDestiny({ value, label });
        } else {
          setSelectedDestiny(null);
        }
      } else {
        setSelectedDestiny(null);
      }
    }
  }, [item, items]);

  const destinyItemOptions = useMemo(() => {
    if (!items) return [];
    const newItems = items
      .filter(({ _id }) => _id !== item._id)
      .map((item) => ({ value: item._id, label: item.title }));
    return newItems;
  }, [items, item]);

  const onChangeDestinySelect = (option) => {
    const { doUpdateItem } = props;
    if (!option) {
      doUpdateItem({ redirectTo: null });
      setSelectedDestiny(null);
      return;
    }

    setSelectedDestiny(option);
    doUpdateItem({ redirectTo: option.value });
  };

  const optionRedirectDestiny = (optionProps) => {
    const { data } = optionProps;
    return (
      <components.Option {...optionProps}>
        <strong>{data.label}</strong>
        <br />
        <span>{data.value}</span>
      </components.Option>
    );
  };

  const renderRedirectDestinySelect = () => {
    if (!answerHandlerOpen) {
      return false;
    }

    return (
      <div style={{ marginTop: 5 }}>
        <Select
          className="pt-0 mb-2"
          label="Bloco de Destino"
          options={destinyItemOptions}
          value={selectedDestiny}
          onChange={onChangeDestinySelect}
          isClearable
          components={{ Option: optionRedirectDestiny }}
        />
      </div>
    );
  };

  return (
    <div className="redirect-settings-options">
      <div className="redirect-settings-options-divider" />
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        Direcionador
        <img
          alt=""
          className={`seta-expander ${
            !answerHandlerOpen ? 'arrow-rotation' : ''
          }`}
          src="/assets/images/icons/seta_close.svg"
        />
      </p>
      {renderRedirectDestinySelect()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  items: state.items.allItems,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RedirectSettings)
);
